import React from 'react';
import { Trophy, Award, Users } from 'lucide-react';
import './Facts.css';

export default function Facts() {
  return (
    <div className="bnt-facts-container" id="interesting-facts">
      <div className="w-full max-w-6xl relative z-10 flex flex-col items-center mx-auto">
        
        <div className="relative w-full flex justify-center mb-16">
          <div className="bnt-halo"></div>
          <h1 className="bnt-header-title">Interesting Facts</h1>
        </div>

        <div className="bnt-facts-grid">
          
          {/* Fact 1: 1st and Only */}
          <div className="bnt-fact-card" style={{ animationDelay: '0.1s' }}>
            <div className="bnt-hud-corner top-left"></div>
            <div className="bnt-hud-corner top-right"></div>
            <div className="bnt-hud-corner bottom-left"></div>
            <div className="bnt-hud-corner bottom-right"></div>
            
            <div className="bnt-icon-wrapper" style={{ animationDelay: '0s' }}>
              <Trophy size={45} strokeWidth={1.5} />
            </div>
            <h2 className="bnt-highlight-text">1ST & ONLY</h2>
            <p className="bnt-description-text">
              Intercollegiate Electronic Systems and Technologies Quiz Show in the Country.
            </p>
          </div>

          {/* Fact 2: Topnotchers */}
          <div className="bnt-fact-card" style={{ animationDelay: '0.3s' }}>
            <div className="bnt-hud-corner top-left"></div>
            <div className="bnt-hud-corner top-right"></div>
            <div className="bnt-hud-corner bottom-left"></div>
            <div className="bnt-hud-corner bottom-right"></div>

            <div className="bnt-icon-wrapper" style={{ animationDelay: '0.5s' }}>
              <Award size={45} strokeWidth={1.5} />
            </div>
            <h2 className="bnt-highlight-text">TOPNOTCHERS</h2>
            <p className="bnt-description-text">
              Where BNT Champions become the Country's highly-regarded Board Exam Topnotchers.
            </p>
          </div>

          {/* Fact 3: 800+ Students */}
          <div className="bnt-fact-card" style={{ animationDelay: '0.5s' }}>
            <div className="bnt-hud-corner top-left"></div>
            <div className="bnt-hud-corner top-right"></div>
            <div className="bnt-hud-corner bottom-left"></div>
            <div className="bnt-hud-corner bottom-right"></div>
            
            <span className="bnt-badge-year">SINCE 2013</span>
            <div className="bnt-icon-wrapper" style={{ animationDelay: '1s' }}>
              <Users size={45} strokeWidth={1.5} />
            </div>
            <h2 className="bnt-highlight-text">800+</h2>
            <p className="bnt-description-text">
              Students have participated in competing to be the next Brodkast ng Talino Champion.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
}